/* eslint-disable jsx-a11y/no-onchange */
/* eslint-disable jsx-a11y/aria-proptypes */
import React, {useEffect} from 'react';
import {CBForm} from '../../constants/apricotCBform';
import './Dropdown.scss';
import '../SmartDisplay/SmartDisplay.scss';
import {ToolTip} from '../';
import { lockMsg, lockMsgAdmin } from '../../constants/messages';
import { ADMIN_ROLE } from '../../constants/global';

const DropDown = ({apcp, question_tooltip, org_rol, selectId, halfInput, isRequired, selectLabel, selectData, 
  selectValue, onChangeSelectValue, readOnly, showQlock, children}) => {

  useEffect(() => {
      const selecttag = document.querySelector('#sel'+selectId);

      document.querySelectorAll('.cb-floating-label').forEach(elem => {
        CBForm.floatingLabel(elem.querySelector('input'));
      });

   }, []);
  
   
  useEffect(() => { //this will update dropdown with CDS. but wont trigger onChange
    const selecttag = document.querySelector('#sel'+selectId);
    const selPlugin = CBForm.customSelectElement({
      elem: selecttag
    });
    document.querySelectorAll('.cb-floating-label').forEach(elem => {
      CBForm.floatingLabel(elem.querySelector('input'));
    });
   
     selPlugin.change();
  }, [selectValue]);








  const GenerateList = ({optionData}) => (
    optionData.map((data, id) => <option id={`${selectId}-${id}`} key={`${selectId}-${id}`} value={data}> {data} </option>)
  );

  const optionselectdata = selectData===null?[]:selectData;
  return (
    <div className='DDcontainer col-md-12'>
      <div id={`selectid1-${selectId}`}>
        <div id={`selectid2-${selectId}`} className='cb-select'>


        <div className={`display-flex ${halfInput?'col-md-12':'col-md-6'}`} >
            {children}
            <label id={`label-${selectId}`} htmlFor={`sel${selectId}`} className={`${(isRequired)?'cb-required':''}`}>
              {selectLabel}
            </label>
            {
              !apcp&&question_tooltip?<ToolTip tooltipid={`smartdisplayDropdown${selectId}id`} 
                                        tooltipMsg={question_tooltip} 
                                        innerMsg={<span className="cb-icon cb-user"></span>} 
                                        className={'questionToolTip'}
                                        />
                                        :''
            }
          </div>

          <div id={`div-${selectId}`} className={`lineupinput ${halfInput?'col-md-12':'col-md-6'}`}>
            <select id={`sel${selectId}`}
              value={selectValue}
              aria-invalid='false'
              aria-required={`${(isRequired)?'true':''}`}
              data-testid='dropdowntestid'
              disabled={readOnly}
              aria-readonly={readOnly}
              aria-describedby={`selectid4-${selectId}`}
              onChange={ async (event) => {
               await onChangeSelectValue(event.target.value);
              }}
            >
              <GenerateList optionData={['', ...optionselectdata]} />
            </select>
            {showQlock?
                <ToolTip tooltipid={`Dropdowntooltip${selectId}`} tooltipMsg={org_rol===ADMIN_ROLE?lockMsgAdmin:lockMsg}
                className={'cb-icon cb-lock'} />:''
              }
          </div>
        </div>
      </div>
      <p id={`selectid4-${selectId}`} style={{display: 'none'}}>Success</p>
      <p id={`selectid5-${selectId}`} style={{display: 'none'}}>Error</p>
    </div>
  );
};

export default DropDown;